// extracted by mini-css-extract-plugin
export default {"list":"Card_list__YDiH1","card-container":"Card_card-container__33bCa","card":"Card_card__Czp91","time":"Card_time__FGdpx","subtitle":"Card_subtitle__EDDpP"};